import { Component, OnInit } from '@angular/core';
import { MydiaryService } from 'src/app/services/mydiary.service';

@Component({
  selector: 'app-pending-diary-weeks-team',
  templateUrl: './pending-diary-weeks-team.component.html',
  styleUrls: ['./pending-diary-weeks-team.component.css']
})
export class PendingDiaryWeeksTeamComponent implements OnInit {
  partnerId: any;
  reportList: any;
  showExportToExcel: boolean = false;

  constructor(private mydiaryService: MydiaryService) { }

  ngOnInit(): void {
     this.partnerId = localStorage.getItem('id');
    this.mydiaryService.getPendingDiaryWeeksForTeam(this.partnerId).subscribe((resp: any) => {
      console.log('pending diary weeks for team', resp);
      this.reportList = resp;
      if (this.reportList.length > 0) {
      this.showExportToExcel = true;
      } else {
        this.showExportToExcel = false;
      }
    });
  }

  goBack() {
    window.history.back();
  }

  exportToExcel() {
    this.mydiaryService.exportPendingDiaryWeeksForTeamToExcel(this.partnerId).subscribe((resp: any) => {
       const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "Pending_Diary_Weeks_Team.xlsx";
      link.click();
    });
}
}
